import React from 'react';
import { WebsiteDesignProps } from './types';
import { Utensils, ChefHat, Flame } from 'lucide-react';
import { Button } from "@/components/ui/button";

const CulinaryInstitute: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Le Petit Chef";

    return (
        <div className="bg-white text-stone-800 min-h-screen font-serif">
            <nav className="p-6 flex justify-center border-b border-stone-100">
                <div className="flex flex-col items-center">
                    <div className="mb-2 text-[#b91c1c]">
                        <ChefHat size={32} />
                    </div>
                    <div className="text-2xl font-bold tracking-tight uppercase text-stone-900 border-b-2 border-[#b91c1c] pb-1 mb-1">
                        {schoolName}
                    </div>
                    <div className="text-xs font-sans font-bold uppercase tracking-[0.3em] text-stone-400">
                        School of Culinary Arts
                    </div>
                </div>
            </nav>

            <header className="relative h-[70vh]">
                <img src="https://images.unsplash.com/photo-1556910103-1c02745a30bf?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover" alt="Kitchen" />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                    <div className="text-center text-white p-8 border border-white/30 backdrop-blur-sm bg-black/20 max-w-2xl">
                         <span className="text-xs font-sans font-bold uppercase tracking-[0.3em] mb-4 block">Master the Craft</span>
                         <h1 className="text-5xl md:text-7xl italic mb-6">Taste. Technique. Tradition.</h1>
                         <Button className="bg-white text-black hover:bg-stone-100 font-sans font-bold uppercase tracking-widest px-8 rounded-none mt-4">
                             View Courses
                         </Button>
                    </div>
                </div>
            </header>

            <section className="py-20 container mx-auto px-8 max-w-4xl text-center">
                <p className="text-2xl italic text-stone-500 leading-relaxed mb-12">
                    "Cooking is an art, but all art requires knowing something about the techniques and materials."
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 font-sans">
                     <div className="flex flex-col items-center">
                         <div className="w-16 h-16 rounded-full bg-red-50 text-red-700 flex items-center justify-center mb-4">
                             <Utensils size={24} />
                         </div>
                         <h3 className="font-bold uppercase tracking-widest text-sm mb-2">Plating</h3>
                         <p className="text-stone-500 text-sm">Visual composition and presentation aesthetics.</p>
                     </div>
                     <div className="flex flex-col items-center">
                         <div className="w-16 h-16 rounded-full bg-orange-50 text-orange-700 flex items-center justify-center mb-4">
                             <Flame size={24} />
                         </div>
                         <h3 className="font-bold uppercase tracking-widest text-sm mb-2">Heat Control</h3>
                         <p className="text-stone-500 text-sm">Mastering fire, temperature, and timing.</p>
                     </div>
                     <div className="flex flex-col items-center">
                         <div className="w-16 h-16 rounded-full bg-stone-100 text-stone-700 flex items-center justify-center mb-4">
                             <ChefHat size={24} />
                         </div>
                         <h3 className="font-bold uppercase tracking-widest text-sm mb-2">Management</h3>
                         <p className="text-stone-500 text-sm">Running a sustainable and profitable kitchen.</p>
                     </div>
                </div>
            </section>
        </div>
    );
};

export default CulinaryInstitute;
